///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'


declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ExecutiveDeploymentReport/executiveDeploymentReport.html'
})

export class ExecutiveDeploymentComponent implements OnInit {
    constants: Constants;
    timesheetItems: any = [];
    userDetail: any;
    userList: any = [];
    objTotalTimeSpent: any =[];
    objSiteUserItem: any = [];
    getExecutiveUrl:any;
    showAll:any = true;
    public showLoader = false;
 
    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'TaskType_Id': "", 'TaskGroup_Id': "", 'TeamId': "", 'UserId': "" };

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //  this.filter={'TeamId': this.timesheetItems.TeamID, 'UserId': this.timesheetItems.SiteUserId}
        this.filter.TeamId = "";
    }

    ngOnInit() {

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        //console.log(newDate)
        this.filter.FromDate = newDate;
        this.GetUserList();
        this.GetTimesheet();
    }

    ExportItems() {
        ExportToExcel(this.timesheetItems, "Timesheet Details",
            ["Username", "Project_Title", "TimeSpent"],
            ["User", "Project", "Time Spent (mins)"]);
    }
    ExportAllUsers() {
        ExportToExcel(this.timesheetItems, "Timesheet Details",
            ["Name", "DaysPlusMinutes", "TimeSpent","Difference"],
            ["User", "Days Worked/Minute", "Minutes Reported","Missing Minutes"]);
    }

    ngAfterViewInit() {



        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

    }



    public clearFilter() {
        this.filter = { 'ProjectId': "", 'TaskType_Id': "", 'UserId': "", 'TeamId': "", 'TaskGroup_Id': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };
        this.filter.TeamId = "";
        var dt = new Date();
    var month = new Array();
    month[0] = "01";
    month[1] = "02";
    month[2] = "03";    
    month[3] = "04";
    month[4] = "05";
    month[5] = "06";
    month[6] = "07";
    month[7] = "08";
    month[8] = "09";
    month[9] = "10";
    month[10] = "11";
    month[11] = "12";
    var mth = month[dt.getMonth()];
    var yr = dt.getFullYear();
    var newDate ='01/'+mth+'/'+yr;
    //console.log(newDate)
    this.filter.FromDate = newDate;
    }

   
    GetUserList() {
        this.showLoader = true;
        this._httpService.ajaxPost("Users/GetUsers",
            {
                "IsActive": this.constants.enumUserStatus["Active"],
                "Role": null,
                "Site": null,
                "Team":this.userDetail.TeamID,
                "UserId":this.userDetail.SiteUserId
            }).subscribe(
            data => {
                this.userList = data["Users"];
                $(".project").val('').selectpicker('refresh');
            },
            err => {
                console.log("GetUserList Failed");
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }



    GetTimesheet() {
        this.showLoader = true;
        var UserId = 0
        if (this.filter.UserId == "") {
            //UserId = this.userDetail.SiteUserId
            this.getExecutiveUrl="ExecutiveDeployment/GetExecutiveReportForAllUser";
            this.showAll = true;
        }
        else {
            UserId = this.filter.UserId
            this.getExecutiveUrl="ExecutiveDeployment/GetExecutiveReport";
             this.showAll = false;
        }
        
        var TeamId = 0
        if (this.filter.TeamId == "") {
            TeamId = this.userDetail.TeamID
        }
        else {
            TeamId = this.filter.TeamId
        }
        this._httpService.ajaxPost(this.getExecutiveUrl,
            {
                "UserId": UserId,
                "ProjectId": null,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,
                "TeamId": TeamId,
                "TaskId": null,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(
            data => {
                this.timesheetItems = data["Report"];
                this.objTotalTimeSpent = 0
                this.timesheetItems.forEach(element => {
                    if (element.TimeSpent == "") {
                        element.TimeSpent = 0;
                    }
                    if(element.Days != null && element.Days != "")
                    {
                        element.DaysPlusMinutes = element.Days+'/'+element.ActualTime;
                    }
                    // else
                    // {
                        if(element.TimeSpent != "" && element.TimeSpent != null)
                    this.objTotalTimeSpent += parseInt(element.TimeSpent);
                    //}
                });
            },
            err => {
                console.log("Get Executive Deployment Report Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            });


    
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ExecutiveDeploymentReport/executiveDeploymentReport.component.ts
 **/